var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":"textarea","rows":8,"placeholder":_vm.placeholder},model:{value:(_vm.inner),callback:function ($$v) {_vm.inner=$$v},expression:"inner"}})
}
var staticRenderFns = []

export { render, staticRenderFns }